import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomField } from '../../../../../../../models/entities/custom-field';
import { GrowlerService } from '../../../../../../../services/growler.service';
import { OrganizationService } from '../../../../../../../services/organization/organization.service';

export interface OrgCustomFieldEditorDialogInput
{
    type: 'unit' | 'vendor' | 'member';
    field: CustomField;
}

@Component({
    selector: 'app-custom-field-editor',
    templateUrl: './custom-field-editor.component.html',
})
export class CustomFieldEditorComponent implements OnDestroy
{
    /** Value when adding or editing a field */
    newFieldName: string = '';
    /** Title, depends on add/edit and model */
    title: string;
    /** UX control if submitting */
    isSubmitting: boolean = false;

    constructor(
            private _dialogRef: MatDialogRef<CustomFieldEditorComponent>,
            private _growler: GrowlerService,
            private _organizationsService: OrganizationService,
            @Inject(MAT_DIALOG_DATA) public data: OrgCustomFieldEditorDialogInput,
    ) {
        if (data.field) {
            this.newFieldName = data.field.name;
            this.title = `Edit ${this.data.type} Custom Field`;
        } else {
            this.title = `Add ${this.data.type} Custom Field`;
        }
    }

    onSubmit(): void {
        if (this.isSubmitting) {
            return;
        }
        if (!this.newFieldName || this.newFieldName === '') {
            this._growler.error('Oops', 'The field name is required');
            return;
        }

        this.isSubmitting = true;
        const request = {name: this.newFieldName};

        const sub = this.data.field ?
                this._organizationsService.editCustomFieldForOrganization(this.data.type, this.data.field.id, request) :
                this._organizationsService.createCustomFieldForOrganization(this.data.type, request);

        sub.subscribe(
                () => {
                    const str = this.data.field ? ' updated.' : ' added.';
                    this._growler.success('Success', 'Your custom field has been ' + str);
                    this.close(this.newFieldName);
                },
                () => {
                    this._growler.error('Error', 'There was a problem adding your custom field. Please try again later.');
                    this.close();
                },
        );
    }

    close(andRefresh = '') {
        this._dialogRef.close(andRefresh);
    }

    ngOnDestroy(): void {
    }
}
